import React, { useEffect, useState } from 'react';
import Header from './Header';
import EventBanner from './EventBanner';
import Hero from './Hero';
import VoucherPromo from './VoucherPromo';
import About from './About';
import Benefits from './Benefits';
import Experts from './Experts';
import Pricing from './Pricing';
import WhatToExpect from './WhatToExpect';
import FinalCTA from './FinalCTA';
import CTA from './CTA';
import Footer from './Footer';
import { normalizeLandingPageText } from '../utils/normalizeLandingPageText';

const LandingPage = () => {
  const [contactMessage, setContactMessage] = useState(null);

  useEffect(() => {
    const root = document.getElementById('root');
    if (!root) return undefined;

    const normalize = () => normalizeLandingPageText(root);
    normalize();

    const observer = new MutationObserver(normalize);
    observer.observe(root, {
      childList: true,
      characterData: true,
      subtree: true
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (window.location.hash !== '#platzsichern') return undefined;

    const scrollToBookingForm = () => {
      const element = document.getElementById('platzsichern');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    };

    const firstFrame = window.requestAnimationFrame(() => {
      window.requestAnimationFrame(scrollToBookingForm);
    });
    const fallbackTimer = window.setTimeout(scrollToBookingForm, 400);

    return () => {
      window.cancelAnimationFrame(firstFrame);
      window.clearTimeout(fallbackTimer);
    };
  }, []);

  const handleVoucherRequest = () => {
    setContactMessage({
      text: 'Gutschein anfragen',
      id: Date.now()
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-stone-50 to-amber-50">
      <EventBanner />
      <Header />
      <VoucherPromo onRequestVoucher={handleVoucherRequest} />
      <Hero />
      <About />
      <Benefits />
      <Experts />
      <Pricing />
      <WhatToExpect />
      <FinalCTA />
      <CTA prefillMessage={contactMessage} />
      <Footer />
    </div>
  );
};

export default LandingPage;